import { useEffect, useState } from 'react';
import { NotificationParameterType } from '../../generated/ApiClient';
import { useNotificationsBase, enqueueNotification, omitNotifications } from './useNotifications';
import { notificationHandler } from './NotificationModal';
import { storageKey } from './GlobalContext';

export const useParameterNotifications = (
  type: NotificationParameterType,
  id: number | undefined,
  isOpen: boolean
) => {
  const { notifications, onClose, closeSnackbar, isNotificationsFetched } = useNotificationsBase();
  const [suppressedId, setSuppressedId] = useState<number | undefined>(undefined);

  // Drawer neu geöffnet → Sperre aufheben
  useEffect(() => {
    if (isOpen) setSuppressedId(undefined);
  }, [isOpen]);

  // Anderer Typ gewählt → Sperre aufheben
  useEffect(() => {
    if (id !== undefined && id !== suppressedId) {
      setSuppressedId(undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (id === suppressedId || id === undefined || !isNotificationsFetched) return;

    const now = new Date();
    const readMessages = localStorage.getItem(storageKey)?.split(';') ?? [];

    const relevant = notifications
      .filter((x) => x.parameters?.some((p) => p.type === type && p.id === id))
      .filter((x) => x.validFrom <= now && (x.validTo === undefined || x.validTo >= now))
      .filter((x) => !readMessages.includes(x.id));

    const popUpNotifications = relevant.filter((x) => x.isPopUp);
    const pushNotifications = relevant.filter((x) => !x.isPopUp);

    const snackbarIds = pushNotifications.map((x) => x.id);
    pushNotifications.forEach((x) => enqueueNotification(x, onClose));

    if (popUpNotifications.length) {
      notificationHandler.confirm(
        () =>
          omitNotifications(
            popUpNotifications.filter((x) => !x.isRecurring).map((x) => x.id)
          ),
        popUpNotifications
      );
    }

    return () => {
      snackbarIds.forEach((snackbarId) => closeSnackbar(snackbarId));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, suppressedId, isNotificationsFetched]);

  return () => setSuppressedId(id);
};
